import { callAct, isOk } from './apiConfig';

/*
 * gallery — the business's photo gallery (ניהול העסק > גלריה), server-backed + multi-tenant.
 * Uploads are re-encoded + stored server-side (galleryUpload); images are served from
 * /media/gallery/<businessID>/<file>.jpg. Item shape: { id, filePath, caption, isCover }.
 */

function normalize(row) {
    return {
        id: row.ID ?? row.id,
        filePath: row.filePath ?? '',
        caption: row.caption ?? '',
        isCover: String(row.isCover) === '1',
    };
}

export async function listGallery() {
    try {
        const envelope = await callAct('galleryList', {});
        if (isOk(envelope) && Array.isArray(envelope.data)) return envelope.data.map(normalize);
    } catch (e) { /* act unavailable */ }
    return [];
}

// Upload one image (base64 data-URI or raw base64) → { ok, id, filePath }.
export async function uploadImage(imageBase64, caption = '') {
    try {
        const envelope = await callAct('galleryUpload', { imageBase64, caption });
        return { ok: isOk(envelope), id: envelope?.data?.ID, filePath: envelope?.data?.filePath };
    } catch (e) { return { ok: false }; }
}

export async function deleteImage(id) {
    try {
        const envelope = await callAct('galleryDelete', { ID: id });
        return { ok: isOk(envelope) };
    } catch (e) { return { ok: false }; }
}

export async function setCoverImage(id) {
    try {
        const envelope = await callAct('gallerySetCover', { ID: id });
        return { ok: isOk(envelope) };
    } catch (e) { return { ok: false }; }
}

export default { listGallery, uploadImage, deleteImage, setCoverImage };
